import { graphql } from '@generated/gql';

export const INNER_WORKFLOW_FETCH_WORKFLOW_OBJECT_TYPE =
  graphql(/** GraphQL */ `
  query innerWorkflowFetchWorkflowObjectType($workflowId: ObjectID!) {
    fetchWorkflow(workflowId: $workflowId) {
      workflow {
        id
        objectType
      }
    }
  }
`);
